import { StyleSheet } from 'react-native';
import { PALETTE, SIZES, TYPOGRAPHY } from '../../../../../../../src/constants';

export default StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    marginHorizontal: SIZES.appHorizontalSpace,
    paddingTop: 14,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
  securityName: {
    paddingBottom: 10,
    // fontSize: TYPOGRAPHY.font.size.header2,
    // color: PALETTE.secondaryActive
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  label: {
    fontSize: TYPOGRAPHY.font.size.large20,
    color: PALETTE.primaryText,
  },
  value: {
    fontSize: TYPOGRAPHY.font.size.large18,
    color: PALETTE.secondaryActive,
  },
});
